const PORTABILITY_FORM_DATA_KEY_STORAGE = 'PORTABILITY_FORM_DATA';
const LOAN_FORM_DATA_KEY_STORAGE = 'LOAN_FORM_DATA';

const FORM = {
	ADDRESS: 'address',
	DATE_OF_EMPLOYMENT: 'dateOfEmployment',
	EMAIL: 'email',
	LICENSE_PLATE: 'licensePlate',
	EMAIL_INSTITUTION: 'emailInstitution',
	FINANCIAL_INSTITUTION_NAME: 'financialInstitutionName',
	FINANCIAL_INSTITUTION: 'financialInstitution',
	FINISH: 'finish',
	FIRST_NAME: 'firstName',
	ID: 'id',
	KNOCKOUT: 'knockout',
	LAST_NAME: 'lastName',
	LOAN_INSTALLMENT_NUMBER: 'loanInstallmentNumber',
	INSTALLMENT_NUMBER: 'installmentNumber',
	LOCALITY: 'locality',
	NATIONAL_ID: 'nationalId',
	OVER_INSTALLMENT_NUMBER: 'overSixInstallment',
	PHONE: 'phone',
	PHONE_INSTITUTION: 'phoneInstitution',
	REGION: 'region',
	SALARY: 'salary',
	SCORING: 'scoring',
	SERIAL_NUMBER_ID: 'serialNumberId',
	SETTLEMENT_CERTIFICATE_ID: 'settlementCertificateId',
	TOUCH_POINT_SELECTED: 'touchPointSelected',
	VEHICLE_PLATE: 'vehiclePlate',
	VEHICLE_VALUE: 'vehicleValue',
	VEHICLE_YEAR: 'vehicleYear',
	VERSION: 'version',
	ACCEPT_TERMS: 'acceptTerms',
	OTHER_FINANCIAL: 'otherFinancialInstitution',
	DOWN_PAYMENT: 'downPayment',
	JOB_TYPE: 'jobType',
	VEHICLE_TYPE: 'vehicleType',
	FULL_NAME: 'fullName',
	VEHICLE_BRAND: 'vehicleBrand',
	COUNTY: 'county',
	BRAND: 'brand',
	CONSENT_CHECKED: 'consentChecked',
};

const QUOTATION_DTO_FORM = {
	FULL_NAME: 'nombreCompleto',
	RUT: 'rut',
	EMAIL: 'correo',
	TELEPHONE: 'telefono',
	ID: 'idVehiculo',
	NAME_ENTITY: 'nameEntities',
	FINANCIAL_INSTITUTION_RUT: 'financialInstitutionRUT',
	ATTACHMENT: 'attachment',
	NUMBER_OPERATIONS: 'numberOptions',
};

const YUP = {
	FIELD_REQUIRED: 'Campo Requerido',
	TERMS_MUST_ACCEPT: 'Los terminos y condiciones deben ser aceptados',
	CONSENT_ACCEPT: 'Debes autorizar la consulta de información para continuar.',
};

const LAYOUT_ITEM = {
	TYPE: {
		INPUT: 'input',
		SELECT: 'select',
		CHECKBOX: 'checkbox',
		RADIO_BUTTON: 'radiobutton',
		FILE: 'file',
		CONSENT_CHECKBOX: 'consentCheckbox',
	},
};

export {
	PORTABILITY_FORM_DATA_KEY_STORAGE,
	LOAN_FORM_DATA_KEY_STORAGE,
	FORM,
	YUP,
	LAYOUT_ITEM,
	QUOTATION_DTO_FORM,
};
